import { TimePeriodDays } from 'app/developer-v3/hooks/useIntegrationInsights';
import { MonthlyActiveUsers } from 'app/developer-v3/hooks/useQueryInsightsMonthlyActiveUsers';

export type ValuesOf<T> = T[keyof T];

export const TimePeriod = {
  Last_Seven_days: 'Last 7 days',
  Last_Thirty_days: 'Last 30 days',
  Last_Ninety_days: 'Last 90 days',
} as const;
// Automated migration: this file was previously ignored by ESLint. Fix this violation if you touch this area of the code.
// eslint-disable-next-line no-redeclare
export type TimePeriod = ValuesOf<typeof TimePeriod>;

type NumberItem = {
  label: string;
  value: number;
};

export const defaultSelectedValuePeriodDays = TimePeriodDays.Last_Thirty_days;

export const defaultInitialSelectedItem = {
  label: TimePeriod.Last_Thirty_days,
  value: defaultSelectedValuePeriodDays,
};

export function generateYearsDropdownOptions(
  monthlyActiveUsers: MonthlyActiveUsers[]
): NumberItem[] {
  const seenYears: Record<number, boolean> = {};
  const dropDownYearOptions: NumberItem[] = [];

  // include the current year by default, if there is no data show the no results state
  const currentYear = new Date().getFullYear();
  seenYears[currentYear] = true;
  dropDownYearOptions.push({
    label: currentYear.toString(),
    value: currentYear,
  });

  for (const { activity_month_end_date } of monthlyActiveUsers) {
    const year = new Date(activity_month_end_date).getFullYear();
    if (!seenYears[year]) {
      seenYears[year] = true;
      dropDownYearOptions.push({
        label: year.toString(),
        value: year,
      });
    }
  }

  // sort options in descending order by year
  dropDownYearOptions.sort((a, b) => b.value - a.value);

  return dropDownYearOptions;
}

export const timePeriodDaysItems = [
  {
    label: TimePeriod.Last_Seven_days,
    value: TimePeriodDays.Last_Seven_days,
  },
  {
    label: TimePeriod.Last_Thirty_days,
    value: TimePeriodDays.Last_Thirty_days,
  },
  {
    label: TimePeriod.Last_Ninety_days,
    value: TimePeriodDays.Last_Ninety_days,
  },
];

export async function sleep(duration: number): Promise<void> {
  await new Promise(resolve => {
    setTimeout(resolve, duration);
  });
}

const div = document.createElement('div');
export function escapeHTML(text: string): string {
  div.textContent = text;
  return div.innerHTML;
}

export const PartnerInteractionTypeHumanized = {
  all: 'All Embeds',
  workflow_api: 'Workflow API',
  workflow_element: 'Workflow Element',
} as const;

export const PartnerInteractionType = {
  all: 'all',
  workflow_api: 'workflow_api',
  workflow_element: 'workflow_element',
} as const;
// Automated migration: this file was previously ignored by ESLint. Fix this violation if you touch this area of the code.
// eslint-disable-next-line no-redeclare
export type PartnerInteractionType = ValuesOf<typeof PartnerInteractionType>;

export const partnerEmbedTypeItems = [
  {
    label: PartnerInteractionTypeHumanized.all,
    value: PartnerInteractionType.all,
  },
  {
    label: PartnerInteractionTypeHumanized.workflow_api,
    value: PartnerInteractionType.workflow_api,
  },
  {
    label: PartnerInteractionTypeHumanized.workflow_element,
    value: PartnerInteractionType.workflow_element,
  },
] as const;

export function convertToPercentage(value: number): number {
  const percentage = value * 100;
  return Number.isInteger(percentage)
    ? percentage
    : Number(percentage.toFixed(1));
}
